module.exports = __webpack_public_path__ + "static/img/bilancaprihodi.d842dc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/bilancaprihodi.png
// module id = NxS+
// module chunks = 0